module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/vi_2-3b2620aa08e1de1edb34ab29c96f04f3.jpg";